import appInfo from "@common/appInfo";
import { replaceQueryString } from "@common/lib/url";
import { type BunnyVideoProps } from "./component";

export const getSrc = (props: BunnyVideoProps): string => {
  return replaceQueryString(props.url!, {
    autoplay: props.autoPlay ? true : false,
    color: props.color // NOTE: must be the last parameter. There's a bug in our color script https://s3.amazonaws.com/cartly.local/common/bunny/color.js
  });
};

export const isBunnyEmbedUrl = (url: string | null | undefined) => (url || "").includes("//iframe.mediadelivery.net");

export const getDefaultColor = () => {
  const bodyStyles = getComputedStyle(document.body);
  return bodyStyles.getPropertyValue("--color");
};

export const getCdnBaseUrl = (): string => `https://${appInfo.bunny?.hostName}.b-cdn.net`;
